<template>
  <div class="container-fluid __wrapper_">
    <div class="row invitation align-items-center">
      <div class="w-100">
        <div class="text-center invitation__title mb-5">
          <h5><b>Invitation to Collaborate</b></h5>
          <p>Please Fill the Form Below to Start Collaborating with Your Teammates</p>
        </div>
        <form @submit.prevent="registerAccount()">
        <div class="box__bottom">
          <div class="row">
            <div class="col-md-5">
              <div class="input__model1group mb-3">
                <p class="textdefault">Full Name</p>
                <b-form-input
                  name="Fullname"
                  v-model="formAccount.name"
                  v-validate="'required'"
                  placeholder="Enter Your Full Name " />
                <div class="fontstyle__errormsg">{{ errors.first('Fullname') }}</div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="input__model1group mb-3">
                <p class="textdefault">Position in Company</p>
                <b-form-input
                  name="Position"
                  v-model="formAccount.position"
                  type="text"
                  v-validate="'required'"
                  placeholder="Enter Your Work Position" />
                <div class="fontstyle__errormsg">{{ errors.first('Position') }}</div>
              </div>
            </div>
            <div class="col-md-2">
              <p class="fontstyle__default">Gender</p>
              <div class="options__multipleselect">
                  <multiselect
                    v-model="formAccount.gender"
                    :options="optionGender"
                    label="text"
                    placeholder="Select"
                    name="gender"
                    :searchable="false"
                    :state="errors.first('gender') && false"
                    v-validate="'required'"
                    :show-labels="false"
                    :select-label="''" :deselect-label="''">
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
              </div>
              <p v-if="errors.has('gender')" class="fontstyle__errormsg">
                  {{ errors.first('gender') }}
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5">
              <div class="input__model1group">
                <p class="textdefault">Email Address</p>
                <b-form-input
                  name="Email Address"
                  v-model="formAccount.email"
                  type="email"
                  v-validate="'required'"
                  placeholder="Enter Email Address" />
                <div class="fontstyle__errormsg">{{ errors.first('Email Address') }}</div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="input__model1group">
                <p class="textdefault">Phone Number</p>
                <div class="row m-0">
                  <span class="labelSpan mr-2" style="width: 34%">+62 Indonesia</span>
                  <div class="removeArrows" style="width: 63.5%">
                    <b-form-input
                      type="number"
                      name="Phone"
                      v-model="formAccount.phone"
                      v-validate="'required'"
                      placeholder="Enter Your Phone Number" />
                    <div class="fontstyle__errormsg">{{ errors.first('Phone') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box__bottom">
          <div class="row">
            <div class="col-md-6">
              <div class="input__model1group inputpassword marginright3">
                <p class="textdefault">Password</p>
                <b-input-group>
                  <b-form-input
                    name="Password"
                    v-bind:type="fieldType1"
                    v-model="formPassword.pass"
                    v-validate="'required|verify_password'"
                    placeholder="Enter Password" />
                  <template #append>
                  <div @click="toggleType1">
                      <img class="passwordvalue__eyesabsolute" src="@/assets/image/icon/icon-eye-slash.png" v-if="fieldType1=='password'">
                      <img class="passwordvalue__eyesabsolute open" src="@/assets/image/icon/icon-eye.png" v-if="fieldType1=='text'">
                    </div>
                  </template>
                </b-input-group>
                <div v-if="errors.has('Password')" class="fontstyle__errormsg mt-1">
                  {{ errors.first('Password') }}
                </div>
                <div v-else-if="!formPassword.pass" style="font-size: 12px" class="mt-1">
                    Use 8 or more characters with a mix of small and capital letters, and numbers.
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="input__model1group inputpassword">
                <p class="textdefault">Password Confirmation</p>
                <b-input-group>
                  <b-form-input
                    name="Password confirmation"
                    v-bind:type="fieldType2"
                    v-model="formPassword.confPass"
                    v-validate="'required'"
                    placeholder="Enter Password Confirmation" />
                  <template #append>
                  <div @click="toggleType2">
                      <img class="passwordvalue__eyesabsolute" src="@/assets/image/icon/icon-eye-slash.png" v-if="fieldType2=='password'">
                      <img class="passwordvalue__eyesabsolute open" src="@/assets/image/icon/icon-eye.png" v-if="fieldType2=='text'">
                    </div>
                  </template>
                </b-input-group>
                <div class="fontstyle__errormsg mt-1">{{ errors.first('Password confirmation') }}</div>
              </div>
            </div>
          </div>
          <p class="fontstyle__errormsg text-center">{{this.pass_alert_msg}}</p>
        </div>
        <div class="justify-content-end d-flex">
          <button
            type="submit"
            class="text-center button__bluecorporite">
            Save My Profile and Password
          </button>
        </div>
        <div v-if="isError && isError.status" class="fontstyle__errormsg text-right pt-2">
          <p>Error {{isError.status}} - {{isError.data ? isError.data.message : isError.statusText }}</p>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: '',
  data () {
    return {
      fieldType1: 'password',
      fieldType2: 'password',
      gender_alert_msg: '',
      pass_alert_msg: '',
      formAccount: {
        name: '',
        position: '',
        gender: '',
        email: '',
        phone: '',
        regitrationCode: ''
      },
      formPassword: {
        pass: '',
        confPass: ''
      },
      optionPhone: [
        { id: 1, text: '+62', value: '' },
        { id: 2, text: '+91', value: '' },
        { id: 3, text: '+86', value: '' }
      ],
      optionGender: [
        { text: 'Male', value: 'M' },
        { text: 'Female', value: 'F' }
      ],
      submitted: false,
      colabText: ''
    }
  },
  methods: {
    toggleType1: function () {
      if (this.fieldType1 === 'password') {
        this.fieldType1 = 'text'
      } else {
        this.fieldType1 = 'password'
      }
    },
    toggleType2: function () {
      if (this.fieldType2 === 'password') {
        this.fieldType2 = 'text'
      } else {
        this.fieldType2 = 'password'
      }
    },
    removeZeroFirstChar (phoneString) {
      let str = phoneString.toString()
      if (phoneString) {
        if (str.charAt(0) === '0') {
          str = str.substring(1) // remove first character
        }
      }
      return `+62${str}`
    },
    genderCheck () {
      if (this.formPassword.pass !== this.formPassword.confPass) {
        this.pass_alert_msg = 'Password does not match'
        setTimeout(() => (this.pass_alert_msg = ''), 3000)
      }
      if (this.formPassword.pass === this.formPassword.confPass) { this.submitted = true }
    },
    registerAccount () {
      this.$validator.validateAll().then((result) => {
        this.genderCheck()
        if (result) {
          this.modifydata()
        }
      })
    },

    async modifydata () {
      this.genderCheck()
      if (this.submitted === true) {
        const payload = {
          fullname: this.formAccount.name,
          gender: this.formAccount.gender.value,
          email: this.formAccount.email,
          phone: this.removeZeroFirstChar(this.formAccount.phone),
          job: this.formAccount.position,
          userPassword: this.formPassword.pass,
          userPasswordConfirm: this.formPassword.confPass,
          registrationCode: this.formAccount.regitrationCode
        }
        await this.$store.dispatch('invitation/INVITATION_REGISTER', payload)
        await this.collaborateSuccess()
      }
    },

    collaborateSuccess () {
      return new Promise((resolve) => {
        if (this.invitation) {
          this.colabText = `Invitation to Collaborate Has Been Successful.
                        Please Login to Access Andalin Platform.`
          this.$eventHub.$emit('dialog-collaborate-success', this.colabText)
        }
        return resolve()
      })
    }

  },
  computed: {
    ...mapGetters({
      invitation: 'invitation/invitation',
      isError: 'invitation/error'
    })
  },
  mounted () {
    this.formAccount.email = this.$route.query.userEmail || ''
    this.formAccount.regitrationCode = this.$route.query.code || ''
  }
}
</script>



// WEBPACK FOOTER //
// src/view/invitation/index.vue